/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { isMobileApplication } from '../../utilities/MobileUtil';
import { actions, selectors } from '../redux/ducks/systemNotification';
import IconClose from './icons/IconClose';
import Colors from '../styles/Colors';
import DateUtil from '../../utilities/DateUtil';
import { ExternalLink } from './TextLink';
import { Icons } from '../../bphComponents/bundle';
import COLORS from '../styles/Colors';

function mapStateToProps(state) {
  return {
    isNotificationAvailable: selectors.isNotificationAvailable(state),
    phraseId: selectors.getNotificationMessage(state),
    content: selectors.getNotificationContent(state),
    color: selectors.getNotificationColor(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      dismissNotification: actions.dismissNotification,
    },
    dispatch
  );
}

const SystemNotification = props => {
  if (!props.isNotificationAvailable) {
    return null;
  }
  const style = {
    text: {},
    container: {
      backgroundColor: `${props.color}`,
    },
  };

  if (isMobileApplication() && props.phraseId) {
    style.container = {
      ...style.container,
      paddingTop: 5,
      paddingBottom: 5,
    };
    style.text = {
      ...style.text,
      flex: 1,
      textAlign: 'center',
      fontSize: '1rem',
    };
  }

  return (
    <div
      style={style.container}
      className="cmp-systemnotification util-application-frame-forcards-padding"
    >
      <div style={style.text}>
        {
          props.content || <FormattedMessage id={props.phraseId} />
        }
      </div>
      <div className="dismiss-icon" onClick={props.dismissNotification}>
        {props.color === Colors.iconGreen
          ? <Icons.IconCheckmark.Small color={COLORS.gsLightest} />
          : <IconClose.Small color="white" />}
      </div>
    </div>
  );
};
SystemNotification.propTypes = {
  color: PropTypes.string,
  phraseId: PropTypes.string,
  content: PropTypes.any,
  dismissNotification: PropTypes.func,
  isNotificationAvailable: PropTypes.bool,
};

export const VersionUpdateSystemMessage = (props) => {
  return (
    <div className="font-footnote font-color-gsLightest" style={{ marginRight: 12 }}>
      <div style={{ marginBottom: 16 }}>
        <FormattedMessage id="release.updateApp.message" />
      </div>

      {
        props.versionCheckResponse.changes.filter(d => d.breaking).map((d, i) => (
          <div key={i} style={{ marginBottom: 16 }}>
            <div>
              {d.version} - {DateUtil.convertTimestampToSimpleDate(d.release_date)}
            </div>
            <div className="font-color-gsLightest">
              {d.details}
            </div>
          </div>
        ))
      }

      <div>
        <FormattedMessage id="app.store.android.link">
          {
            (url) => (
              <ExternalLink href={url} className="font-footnote font-color-gsLightest">
                {url}
              </ExternalLink>
            )
          }
        </FormattedMessage>
      </div>
    </div>
  );
}
VersionUpdateSystemMessage.propTypes = {
  versionCheckResponse: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(SystemNotification);
